import Editor, { EditorProps } from "@monaco-editor/react";
import { Dispatch, SetStateAction } from "react";

const options: EditorProps["options"] = {
  acceptSuggestionOnCommitCharacter: true,
  acceptSuggestionOnEnter: "on",
  accessibilitySupport: "auto",
  automaticLayout: true,
  codeLens: true,
  colorDecorators: true,
  contextmenu: true,
  cursorSmoothCaretAnimation: "off",
  cursorStyle: "line",
  disableLayerHinting: false,
  disableMonospaceOptimizations: false,
  dragAndDrop: false,
  fixedOverflowWidgets: false,
  folding: true,
  foldingStrategy: "auto",
  fontLigatures: false,
  formatOnPaste: false,
  formatOnType: false,
  hideCursorInOverviewRuler: false,
  links: true,
  mouseWheelZoom: false,
  multiCursorMergeOverlapping: true,
  multiCursorModifier: "alt",
  overviewRulerBorder: true,
  overviewRulerLanes: 2,
  quickSuggestions: true,
  quickSuggestionsDelay: 100,
  readOnly: false,
  renderControlCharacters: false,
  renderFinalNewline: "on",
  renderLineHighlight: "all",
  renderWhitespace: "none",
  revealHorizontalRightPadding: 30,
  roundedSelection: true,
  rulers: [],
  scrollBeyondLastColumn: 5,
  scrollBeyondLastLine: true,
  selectOnLineNumbers: true,
  selectionClipboard: true,
  selectionHighlight: true,
  showFoldingControls: "mouseover",
  smoothScrolling: false,
  suggestOnTriggerCharacters: true,
  wordBasedSuggestions: true,
  wordSeparators: "~!@#$%^&*()-=+[{]}|;:'\",.<>/?",
  wordWrap: "off",
  wordWrapBreakAfterCharacters: "\t})]?|&,;",
  wordWrapBreakBeforeCharacters: "{([+",
  wordWrapColumn: 80,
  wrappingIndent: "none",
};

export default function MonacoEditor(props: {
  value: string;
  setJsonEditorData: Dispatch<SetStateAction<string>>;
  setJsonIsValid: Dispatch<SetStateAction<boolean>>;
}) {
  return (
    <Editor
      defaultLanguage="json"
      language="json"
      theme="vs-dark"
      onChange={(value) => {
        props.setJsonEditorData(value ?? "");
      }}
      onValidate={(markers) => {
        if (markers.length === 0) {
          props.setJsonIsValid(true);
        } else {
          props.setJsonIsValid(false);
        }
        console.log(markers);
      }}
      value={props.value}
      options={options}
    />
  );
}
